import React from "react"

export default function Fields(props: any) {
    const {children, className} = props
    const classes = ["fields"]

    if (className) {
        classes.push(className)
    }

    return (
        <div className={classes.join(" ")}>
            {children}
        </div>
    )
};